"use client";

import { ContentWrapper } from "@/components/Home/Common/ContentWrapper";
import { HTMLParser } from "@/components/ui/HtmlParser";

export const PropertyListSEOContent = ({ content }: { content: string }) => {
  return (
    <ContentWrapper className="bg-gray-200 !p-4 rounded-md ">
      <HTMLParser htmlContent={content} variant="sm" />
    </ContentWrapper>
  );
};
